"use client";

import { Moon, Sun } from "lucide-react";
import { useEffect, useState } from "react";

export function ThemeToggle() {
  const [dark, setDark] = useState(false);

  useEffect(() => {
    const frame = window.requestAnimationFrame(() => {
      const savedDark =
        window.localStorage.getItem("krosspaths-theme") === "dark";
      setDark(savedDark);
      document.documentElement.dataset.theme = savedDark ? "dark" : "light";
    });
    return () => window.cancelAnimationFrame(frame);
  }, []);

  function toggle() {
    const next = !dark;
    setDark(next);
    document.documentElement.dataset.theme = next ? "dark" : "light";
    window.localStorage.setItem("krosspaths-theme", next ? "dark" : "light");
  }

  return (
    <button
      className="icon-button"
      type="button"
      onClick={toggle}
      aria-label={`Use ${dark ? "light" : "dark"} theme`}
    >
      {dark ? <Sun size={19} /> : <Moon size={19} />}
    </button>
  );
}
